module.exports = __webpack_public_path__ + "img/5.e68958ab.png";